module.exports = __webpack_public_path__ + "media/Loops Pad.640c95b9.wav";